/**
 * @file WelcomeBlock.js
 * @description Per-plan-year welcome message block.
 */

import RichTextContent from '../../ui/RichTextContent';
import { hasTextContent } from '../../../utils/utils';
import styles from './WelcomeBlock.module.scss';

function pickContent(planYearText, fallbackText) {
    if (hasTextContent(planYearText)) {
        return planYearText;
    }
    if (hasTextContent(fallbackText)) {
        return fallbackText;
    }
    return null;
}

export default function WelcomeBlock({ planYearText, fallbackText, enabled }) {
    if (enabled === false) {
        return null;
    }
    const content = pickContent(planYearText, fallbackText);
    if (!content) {
        return null;
    }
    return (
        <div className={styles.wrap}>
            <RichTextContent content={content} />
        </div>
    );
}
